document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  const menuButton = document.querySelector('[data-cfs-menu-toggle]');
  const menuClose = document.querySelector('[data-cfs-menu-close]');
  const mobilePanel = document.querySelector('[data-cfs-mobile-panel]');
  const setMenu = open => { if (!menuButton || !mobilePanel) return; mobilePanel.classList.toggle('open', open); document.body.classList.toggle('cfs-menu-open', open); menuButton.setAttribute('aria-expanded', open ? 'true' : 'false'); };
  if (menuButton) menuButton.addEventListener('click', () => setMenu(!mobilePanel.classList.contains('open')));
  if (menuClose) menuClose.addEventListener('click', () => setMenu(false));

  document.querySelectorAll('[data-cfs-search-toggle]').forEach(toggle => {
    const id = toggle.getAttribute('aria-controls');
    const panel = id ? document.getElementById(id) : document.querySelector('[data-cfs-mobile-search]');
    if (!panel) return;
    toggle.addEventListener('click', () => {
      const open = panel.hasAttribute('hidden');
      if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden','');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) setTimeout(() => panel.querySelector('input[type=search]')?.focus(), 30);
    });
  });


  // One CFS predictive-search implementation for header, mobile header and search page.
  // It searches products + collections, includes SKU/barcode/variant fields and expands common farming synonyms.
  document.querySelectorAll('[data-cfs-predictive-form]').forEach(searchForm => {
    const input = searchForm.querySelector('[data-cfs-predictive-input]');
    const results = searchForm.querySelector('[data-cfs-predictive-results]');
    if (!input || !results) return;
    let timer = null, controller = null, hintTimer = null, hintIndex = 0;
    const hints = (input.dataset.cfsSearchHints || '').split('|').map(v => v.trim()).filter(Boolean);
    const popular = [
      ['Kaiwaka waterproofs','Kaiwaka waterproofs'],
      ['Bekina boots','Bekina boots'],
      ['Electric fencing','electric fencing'],
      ['Calf feeders','calf feeders'],
      ['Animal health','animal health'],
      ['Dairy & parlour','dairy parlour']
    ];
    const escapeHtml = value => String(value == null ? '' : value).replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
    const closeResults = () => { results.hidden = true; results.innerHTML = ''; input.setAttribute('aria-expanded','false'); };
    const renderPopular = () => {
      const chips = popular.map(([label,q]) => `<a class="cfs-search-suggestion" href="${rootPath}search?q=${encodeURIComponent(q)}">${escapeHtml(label)}</a>`).join('');
      results.innerHTML = `<div class="cfs-predictive-title">Popular searches</div><div class="cfs-search-suggestions">${chips}</div><div class="cfs-search-tip">Search by product, brand, SKU, part number or barcode.</div>`;
      results.hidden = false; input.setAttribute('aria-expanded','true');
    };
    const stopHints = () => { if(hintTimer){ clearInterval(hintTimer); hintTimer=null; } };
    const startHints = () => {
      stopHints();
      if(!hints.length || input.value || document.activeElement === input) return;
      input.placeholder = hints[hintIndex % hints.length];
      hintTimer = setInterval(() => {
        if(input.value || document.activeElement === input){ stopHints(); return; }
        hintIndex = (hintIndex + 1) % hints.length;
        input.placeholder = hints[hintIndex];
      }, 2600);
    };
    const moneyText = value => {
      if (value == null) return '';
      if (typeof value === 'string' && /[€£$]/.test(value)) return value;
      const n = Number(value);
      if (!Number.isFinite(n)) return '';
      const currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IE',{style:'currency',currency:currency}).format(n);
    };
    const searchQueries = q => {
      const items = [q];
      const rules = [
        [/\bwellies?\b/i, /\bwellies?\b/ig, 'wellingtons'],
        [/\bwellingtons?\b/i, /\bwellingtons?\b/ig, 'wellies'],
        [/\bfencers?\b/i, /\bfencers?\b/ig, 'energiser'],
        [/\benergisers?\b/i, /\benergisers?\b/ig, 'fencer'],
        [/\benergizers?\b/i, /\benergizers?\b/ig, 'energiser']
      ];
      rules.forEach(([test,replace,replacement]) => {
        if(test.test(q)) items.push(q.replace(replace,replacement));
      });
      return [...new Set(items.map(v => v.trim()).filter(Boolean))].slice(0,3);
    };
    const fetchSuggestions = async (q, signal) => {
      const fields='title,product_type,variants.title,variants.sku,variants.barcode,vendor,tag';
      const url = `${rootPath}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=${encodeURIComponent(fields)}`;
      const response=await fetch(url,{signal,headers:{'Accept':'application/json'}});
      if(!response.ok) throw new Error('predictive search failed');
      const json=await response.json();
      return json?.resources?.results || {};
    };
    const render = (products, collections, q) => {
      const safeProducts = (products || []).filter(p => {
        const u = (p.url || '').toLowerCase();
        const h = (p.handle || '').toLowerCase();
        return h !== 'prescription-fee' && !u.includes('/products/prescription-fee');
      });
      const productRows = safeProducts.slice(0,6).map(p => {
        const image = p.featured_image && (p.featured_image.url || p.featured_image) ? (p.featured_image.url || p.featured_image) : (p.image || '');
        const price = moneyText(p.price);
        return `<a class="cfs-predictive-item" href="${escapeHtml(p.url || '#')}">${image ? `<img src="${escapeHtml(image)}" alt="" loading="lazy">` : '<span class="cfs-predictive-noimage"></span>'}<span><strong>${escapeHtml(p.title)}</strong>${p.vendor ? `<small>${escapeHtml(p.vendor)}</small>` : ''}${price ? `<b>${escapeHtml(price)}</b>` : ''}</span></a>`;
      }).join('');
      const collectionRows = (collections || []).slice(0,3).map(c => `<a class="cfs-predictive-collection" href="${escapeHtml(c.url || '#')}"><span>${escapeHtml(c.title)}</span><b>Shop collection →</b></a>`).join('');
      let html='';
      if(productRows) html += `<div class="cfs-predictive-title">Suggested products</div>${productRows}`;
      if(collectionRows) html += `<div class="cfs-predictive-title cfs-predictive-title--collections">Matching departments & collections</div><div class="cfs-predictive-collections">${collectionRows}</div>`;
      if(!html) html='<div class="cfs-predictive-empty">No matching products yet. Try a brand, SKU or a broader farm term.</div>';
      html += `<a class="cfs-predictive-all" href="${rootPath}search?q=${encodeURIComponent(q)}">See all results for “${escapeHtml(q)}” →</a>`;
      results.innerHTML = html;
      results.hidden = false; input.setAttribute('aria-expanded','true');
    };
    input.addEventListener('input', () => {
      stopHints();
      clearTimeout(timer); const q=input.value.trim();
      if (q.length < 2) { if(controller) controller.abort(); renderPopular(); return; }
      timer=setTimeout(async () => {
        try {
          if (controller) controller.abort(); controller=new AbortController();
          const batches=await Promise.all(searchQueries(q).map(term => fetchSuggestions(term,controller.signal)));
          const productMap=new Map(), collectionMap=new Map();
          batches.forEach(batch => {
            (batch.products || []).forEach(p => { const key=String(p.id || p.url || p.title); if(!productMap.has(key)) productMap.set(key,p); });
            (batch.collections || []).forEach(c => { const key=String(c.id || c.url || c.title); if(!collectionMap.has(key)) collectionMap.set(key,c); });
          });
          render([...productMap.values()], [...collectionMap.values()], q);
        } catch(e){ if(e.name !== 'AbortError') closeResults(); }
      },180);
    });
    input.addEventListener('focus', () => {
      stopHints();
      const q=input.value.trim();
      if(q.length < 2) renderPopular();
      else if(results.innerHTML.trim()){results.hidden=false;input.setAttribute('aria-expanded','true');}
    });
    input.addEventListener('blur', () => { setTimeout(startHints, 180); });
    document.addEventListener('click', e => { if(!searchForm.contains(e.target)) closeResults(); });
    searchForm.addEventListener('keydown', e => { if(e.key==='Escape') closeResults(); });
    startHints();
  });

  const filterButton = document.querySelector('[data-cfs-filter-toggle]');
  const filters = document.querySelector('[data-cfs-filters]');
  if (filterButton && filters) filterButton.addEventListener('click', () => filters.classList.toggle('is-open'));

  document.querySelectorAll('[data-cfs-product]').forEach(productRoot => {
    const form = productRoot.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const addButton = form.querySelector('[data-cfs-add]');
    const variantSelect = form.querySelector('[data-cfs-variant-select]');
    const variantPills = [...form.querySelectorAll('[data-cfs-variant-pill]')];
    const prices = productRoot.querySelectorAll('[data-cfs-price],[data-cfs-price-mobile],[data-cfs-sticky-price]');
    const stocks = productRoot.querySelectorAll('[data-cfs-stock],[data-cfs-stock-mobile]');
    const rx = form.querySelector('[data-cfs-prescription]');
    const sticky = productRoot.querySelector('[data-cfs-sticky-add]');
    const qty = form.querySelector('.cfs-qty');
    let variantAvailable = addButton ? addButton.dataset.available !== 'false' : true;
    let rxReady = !rx;

    productRoot.querySelector('[data-cfs-qty-minus]')?.addEventListener('click', () => { qty.value = Math.max(1, Number(qty.value || 1) - 1); });
    productRoot.querySelector('[data-cfs-qty-plus]')?.addEventListener('click', () => { qty.value = Number(qty.value || 1) + 1; });

    function refreshSticky(){
      if (!sticky) return;
      if (!variantAvailable){ sticky.textContent='Sold out'; sticky.disabled=true; return; }
      sticky.disabled=false;
      sticky.textContent = rx && !rxReady ? 'Choose prescription' : 'Add to cart';
    }
    function syncVariantPills(){
      if (!variantSelect || !variantPills.length) return;
      variantPills.forEach(button => {
        const active = button.dataset.variantId === variantSelect.value;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
    variantPills.forEach(button => button.addEventListener('click', () => {
      if (!variantSelect || button.disabled) return;
      variantSelect.value = button.dataset.variantId;
      variantSelect.dispatchEvent(new Event('change', { bubbles:true }));
    }));

    function readVariantState() {
      if (variantSelect) {
        const option = variantSelect.options[variantSelect.selectedIndex];
        variantAvailable = !!(option && option.dataset.available === 'true');
        if (option && option.dataset.price) prices.forEach(el => el.textContent = option.dataset.price);
        if (option && option.dataset.sku) productRoot.querySelectorAll('[data-cfs-sku]').forEach(el => el.textContent = option.dataset.sku);
        if (option && option.dataset.image) {
          const mainImage = productRoot.querySelector('[data-cfs-main-image] img');
          if (mainImage) { mainImage.src = option.dataset.image; mainImage.srcset = ''; }
          productRoot.querySelectorAll('[data-cfs-thumb]').forEach(t => t.classList.toggle('is-active', !!option.dataset.imageId && t.dataset.imageId === option.dataset.imageId));
        }
      }
      syncVariantPills();
      stocks.forEach(el => { el.textContent = variantAvailable ? 'Available to order' : 'Currently unavailable'; el.classList.toggle('is-out', !variantAvailable); });
      refreshRx(); refreshSticky();
    }
    if (variantSelect) variantSelect.addEventListener('change', readVariantState);

    productRoot.querySelectorAll('[data-cfs-thumb]').forEach(thumb => thumb.addEventListener('click', () => {
      const main = productRoot.querySelector('[data-cfs-main-image] img');
      if (main && thumb.dataset.image) { main.src = thumb.dataset.image; main.srcset = ''; main.removeAttribute('loading'); }
      productRoot.querySelectorAll('[data-cfs-thumb]').forEach(t => t.classList.remove('is-active')); thumb.classList.add('is-active');
    }));

    let vetOpened = false;
    let radios=[], scriptWrap, vetWrap, vetLink, vetConfirm, vetProperty, feeVariantId='';
    function refreshRx(){
      if (!rx){ rxReady=true; if(addButton) addButton.disabled=!variantAvailable; return; }
      const chosen = rx.querySelector('input[name="properties[Prescription option]"]:checked');
      const value = chosen ? chosen.value : '';
      const own = value === 'I already have a valid prescription';
      const arrange = value === 'I need CFS to arrange my prescription';
      if (scriptWrap) scriptWrap.hidden = !own;
      if (vetWrap) vetWrap.hidden = !arrange;
      rxReady = own || (arrange && vetOpened && feeVariantId.length > 0);
      if (addButton) {
        addButton.disabled = !variantAvailable || !rxReady;
        if (!variantAvailable) addButton.textContent = 'Sold out';
        else if (!rxReady) addButton.textContent = 'Choose prescription option above';
        else addButton.textContent = 'Add to cart';
      }
      refreshSticky();
    }
    if (rx) {
      radios = rx.querySelectorAll('input[name="properties[Prescription option]"]');
      scriptWrap = rx.querySelector('[data-script-wrap]'); vetWrap = rx.querySelector('[data-vet-wrap]');
      vetLink = rx.querySelector('[data-vetpal-link]'); vetConfirm = rx.querySelector('[data-vet-confirm]'); vetProperty = rx.querySelector('[data-vetpal-property]');
      feeVariantId = rx.dataset.feeVariantId || '';
      radios.forEach(r => r.addEventListener('change', refreshRx));
      if (vetLink) vetLink.addEventListener('click', () => { vetOpened=true; if(vetConfirm) vetConfirm.hidden=false; if(vetProperty) vetProperty.value='Started'; setTimeout(refreshRx,100); });
    }

    form.addEventListener('submit', async event => {
      if (!variantAvailable) { event.preventDefault(); return; }
      if (!rx) return;
      const chosen = rx.querySelector('input[name="properties[Prescription option]"]:checked');
      if (!chosen || !rxReady) { event.preventDefault(); refreshRx(); rx.scrollIntoView({behavior:'smooth',block:'center'}); return; }
      const arrange = chosen.value === 'I need CFS to arrange my prescription';
      if (!arrange) return;
      event.preventDefault();
      if (addButton) { addButton.disabled=true; addButton.textContent='Adding…'; }
      try {
        const fd=new FormData(form), props={};
        for (const [key,val] of fd.entries()){ const m=key.match(/^properties\[(.+)\]$/); if(m && val) props[m[1]]=val; }
        const rxUid='rx_'+Date.now().toString(36)+'_'+Math.random().toString(36).slice(2,8);
        props['_cfs_rx_uid']=rxUid;
        const payload={items:[{id:Number(fd.get('id')),quantity:Number(fd.get('quantity')||1),properties:props},{id:Number(feeVariantId),quantity:1,properties:{'_cfs_rx_fee_for':rxUid,'Prescription fee for':productRoot.querySelector('h1')?.textContent?.trim()||'Medicine'}}]};
        const response=await fetch(rootPath+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
        if(!response.ok) throw new Error('Cart add failed'); window.location.href=rootPath+'cart';
      } catch(error){ if(addButton){addButton.disabled=false;addButton.textContent='Add to cart';} alert('We could not add this prescription item to the cart. Please try again or contact Country Farm Supplies.'); }
    });

    if (sticky) sticky.addEventListener('click', () => {
      if (rx && !rxReady){ rx.scrollIntoView({behavior:'smooth',block:'center'}); return; }
      if (addButton && !addButton.disabled) addButton.click();
    });
    readVariantState(); refreshRx(); refreshSticky();
  });

  document.querySelectorAll('[data-cfs-remove-line]').forEach(link => link.addEventListener('click', async event => {
    const uid=link.dataset.rxUid; if(!uid) return;
    event.preventDefault();
    try { const cart=await fetch(rootPath+'cart.js').then(r=>r.json()); const updates={}; cart.items.forEach(item=>{ if(item.key===link.dataset.lineKey || (item.properties && item.properties._cfs_rx_fee_for===uid)) updates[item.key]=0; }); await fetch(rootPath+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})}); window.location.reload(); } catch(e){ window.location.href=link.href; }
  }));

  const cartForm=document.querySelector('[data-cfs-cart-form]');
  const updateButton=document.querySelector('[data-cfs-cart-update]');
  if(cartForm && updateButton) updateButton.addEventListener('click', async event => {
    event.preventDefault(); const updates={}; const zeroUids=new Set();
    cartForm.querySelectorAll('[data-cfs-cart-qty]').forEach(input=>{ updates[input.dataset.lineKey]=Number(input.value||0); if(Number(input.value||0)===0 && input.dataset.rxUid) zeroUids.add(input.dataset.rxUid); });
    cartForm.querySelectorAll('[data-rx-fee-for]').forEach(row=>{ if(zeroUids.has(row.dataset.rxFeeFor)) updates[row.dataset.cartLineKey]=0; });
    try { await fetch(rootPath+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})}); window.location.reload(); } catch(e){ cartForm.submit(); }
  });
});
/* CFS V10 product slider controls */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cfs-slider]').forEach(slider => {
    const track = slider.querySelector('[data-cfs-slider-track]');
    const section = slider.closest('.cfs-featured-slider-section');
    const prev = section?.querySelector('[data-cfs-slider-prev]');
    const next = section?.querySelector('[data-cfs-slider-next]');
    if (!track) return;
    const step = () => {
      const card = track.querySelector('.cfs-product-card');
      if (!card) return track.clientWidth * .8;
      const gap = parseFloat(getComputedStyle(track).gap || 0);
      return card.getBoundingClientRect().width + gap;
    };
    const update = () => {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 3;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
    };
    prev?.addEventListener('click', () => track.scrollBy({left:-step(),behavior:'smooth'}));
    next?.addEventListener('click', () => track.scrollBy({left:step(),behavior:'smooth'}));
    track.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);
    update();
  });
});


// CFS V66 brand directory search + A-Z filtering.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cfs-brand-directory]').forEach(directory => {
    const input = directory.querySelector('[data-cfs-brand-search]');
    const buttons = [...directory.querySelectorAll('[data-cfs-brand-letter]')];
    const items = [...directory.querySelectorAll('[data-cfs-brand-item]')];
    const groups = [...directory.querySelectorAll('[data-cfs-brand-group]')];
    const empty = directory.querySelector('[data-cfs-brand-empty]');
    let activeLetter = 'all';

    const apply = () => {
      const q = (input?.value || '').trim().toLowerCase();
      let shown = 0;
      items.forEach(item => {
        const matchesLetter = activeLetter === 'all' || item.dataset.brandLetter === activeLetter;
        const matchesSearch = !q || (item.dataset.brandName || '').includes(q);
        const visible = matchesLetter && matchesSearch;
        item.hidden = !visible;
        if (visible) shown += 1;
      });
      groups.forEach(group => {
        const visibleItems = [...group.querySelectorAll('[data-cfs-brand-item]')].some(item => !item.hidden);
        group.hidden = !visibleItems;
      });
      if (empty) empty.hidden = shown > 0;
    };

    input?.addEventListener('input', apply);
    buttons.forEach(button => button.addEventListener('click', () => {
      activeLetter = button.dataset.cfsBrandLetter || 'all';
      buttons.forEach(b => b.classList.toggle('is-active', b === button));
      apply();
    }));
    apply();
  });
});


/* V79: move the existing, known-good recommendation section close to Add to Cart
   without changing the Shopify product template or main product section schema. */
(function(){
  function moveSmartBoughtTogether(){
    var smart = document.querySelector('[data-cfs-smart-recommendations]');
    var buy = document.querySelector('.cfs-buy-card');
    if (!smart || !buy || smart.dataset.cfsMoved === '1') return;
    smart.dataset.cfsMoved = '1';
    buy.insertAdjacentElement('afterend', smart);
    smart.classList.add('cfs-smart-recommendations--near-buy');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveSmartBoughtTogether);
  } else {
    moveSmartBoughtTogether();
  }
  document.addEventListener('shopify:section:load', moveSmartBoughtTogether);
})();


/* V84 smart add-ons: exact pairings -> Shopify complementary -> category rules -> strong related matches. */
(function(){
  function currency(){return (window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';}
  function formatMajor(value){
    var num=Number(value||0); try{return new Intl.NumberFormat(document.documentElement.lang||'en-IE',{style:'currency',currency:currency()}).format(num);}catch(e){return '€'+num.toFixed(2);}
  }
  function formatMinor(value){
    var num=Number(value||0)/100; try{return new Intl.NumberFormat(document.documentElement.lang||'en-IE',{style:'currency',currency:currency()}).format(num);}catch(e){return '€'+num.toFixed(2);}
  }
  function esc(s){return String(s||'').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c];});}
  function tokens(s){
    var stop=new Set(['the','and','for','with','from','pack','single','small','large','medium','litre','liter','ml','mm','cm','kg','gram','grams','g','l','x','of','in','on','to','a','an','new','farm','country','supplies']);
    return String(s||'').toLowerCase().replace(/[^a-z0-9\s-]/g,' ').split(/[\s-]+/).filter(function(t){return t.length>2&&!stop.has(t)&&!/^[0-9]+$/.test(t);});
  }
  var accessoryWords=['holder','holders','replacement','refill','spare','spares','accessory','accessories','bracket','mount','handle','adapter','adaptor','battery','batteries','charger','case','pouch','belt','cover','nozzle','hose','connector','reel','insulator','lead','leads','filter','filters','wipe','wipes','kit','pump','doser','applicator','gun','injector','blade','blades','head','heads','clip','clips','strap','straps','cap','caps','stand','rack','bag','oil','comb','combs','sock','socks','insole','insoles','lace','laces','earth','stake','stakes','tester','testers','teat','teats','valve','valves','tube','tubing','cartridge','cartridges','disc','discs','block','blocks','bandage','bandages','glove','gloves','trouser','trousers','overtrouser','overtrousers'];
  function score(p,ctx){
    var title=String(p.title||'').toLowerCase(), pt=tokens(title), shared=pt.filter(function(t){return ctx.tokens.indexOf(t)>=0;});
    var s=shared.length*5;
    if (String(p.vendor||'').toLowerCase()===ctx.vendor) s+=2;
    accessoryWords.forEach(function(w){if(title.indexOf(w)>=0 && ctx.title.indexOf(w)<0) s+=4;});
    if(ctx.title.indexOf('boundary blade')>=0 && title.indexOf('boundary blade')>=0 && title.indexOf('holder')>=0) s+=40;
    if(ctx.title.indexOf('clipper')>=0 && /(blade|oil|comb)/.test(title)) s+=14;
    if(/(boot|wellington|footwear|shoe)/.test(ctx.all) && /(sock|insole|lace)/.test(title)) s+=16;
    if(/\bsocks?\b/.test(ctx.title) && /(boot|wellington|dealer boot|safety boot|work boot|shoe)/.test(title)) s+=18;
    if(/\bsocks?\b/.test(ctx.title) && /\bsocks?\b/.test(title)) s-=30;
    if(/(boot|wellington|shoe)/.test(ctx.title) && /(boot|wellington|shoe)/.test(title) && !/(sock|insole|lace)/.test(title)) s-=18;
    if(/(jacket|coat|parka)/.test(ctx.title) && /(jacket|coat|parka)/.test(title)) s-=14;
    if(/(glove|gloves)/.test(ctx.title) && /(glove|gloves)/.test(title)) s-=14;
    if(/(fencer|energiser|energizer)/.test(ctx.all) && /(tester|earth|stake|battery|lead|insulator)/.test(title)) s+=16;
    if(/(reel|electric fencing|fencing)/.test(ctx.all) && /(wire|tape|insulator|post|stake|tester|joiner|connector)/.test(title)) s+=12;
    if(/(calf|lamb).*(feeder|bottle)|milk feeder/.test(ctx.all) && /(teat|valve|tube|tubing|hose)/.test(title)) s+=16;
    if(/(doser|dosing gun|drencher|injector)/.test(ctx.all) && /(hose|nozzle|spare|replacement|needle)/.test(title)) s+=16;
    if(/(bolus|boluses)/.test(ctx.all) && /(applicator|gun|doser)/.test(title)) s+=18;
    if(/hoof/.test(ctx.all) && /(disc|block|glue|bandage|knife|blade|wrap)/.test(title)) s+=12;
    if(/teat/.test(ctx.all) && /(wipe|dip|sprayer|nozzle|cup|brush)/.test(title)) s+=12;
    if(/(trough|drinker)/.test(ctx.all) && /(valve|float|ballcock|fitting|connector)/.test(title)) s+=16;
    if(/(milwaukee|dewalt|makita|power tool|drill|grinder|impact)/.test(ctx.all) && /(battery|charger|case|disc|blade|bit)/.test(title)) s+=14;
    if(/(jacket|coat|parka|waterproof)/.test(ctx.all) && /(trouser|overtrouser|glove|beanie|hat)/.test(title)) s+=9;
    if(/(trouser|pants|bib|brace)/.test(ctx.all) && /(belt|sock|glove)/.test(title)) s+=8;
    return s;
  }
  function context(root){
    var title=String(root.dataset.productTitle||'').toLowerCase();
    var vendor=String(root.dataset.productVendor||'').toLowerCase();
    var type=String(root.dataset.productType||'').toLowerCase();
    var tags=String(root.dataset.productTags||'').toLowerCase();
    var collections=String(root.dataset.productCollections||'').toLowerCase();
    return {title:title,vendor:vendor,type:type,tags:tags,collections:collections,all:[title,vendor,type,tags,collections].join(' '),tokens:tokens(title+' '+type+' '+tags)};
  }
  function smartQueries(ctx){
    var q=[], all=ctx.all, title=String(ctx.title||'');
    function add(){for(var i=0;i<arguments.length;i++){if(arguments[i]&&q.indexOf(arguments[i])<0)q.push(arguments[i]);}}
    if(/boundary blade/.test(all)) add('Boundary Blade Leather Belt Holder','Boundary Blade Holder');
    if(/\bsocks?\b/.test(title)) add((ctx.vendor+' boots').trim(),(ctx.vendor+' wellingtons').trim(),'wellington boots','dealer boots','work boots');
    else if(/(boot|wellington|footwear|shoe|dealer boot|safety boot)/.test(all)) add('farm socks','work socks','boot socks','insoles');
    if(/clipper/.test(all)) add((ctx.vendor+' clipper blades').trim(),'clipper blades','clipper oil','clipper comb');
    if(/(fencer|energiser|energizer)/.test(all)) add('electric fence tester','earth stake','fencer battery','fence lead');
    if(/(electric fencing|fencing|reel)/.test(all)) add('electric fence tester','fencing insulators','fencing wire','fencing tape','fence connector');
    if(/(calf|lamb).*(feeder|bottle)|milk feeder/.test(all)) add('calf feeder teat','calf teat','feeder valve','feeder tubing');
    if(/(doser|dosing gun|drencher|injector)/.test(all)) add('dosing gun hose','dosing nozzle','dosing gun spares');
    if(/(bolus|boluses)/.test(all)) add('bolus applicator','bolus gun');
    if(/hoof/.test(all)) add('hoof blocks','hoof glue','hoof bandage','hoof disc');
    if(/teat/.test(all)) add('teat wipes','teat dip','teat sprayer');
    if(/(trough|drinker)/.test(all)) add('trough valve','float valve','ballcock');
    if(/(sprayer|pressure washer)/.test(all)) add('sprayer nozzle','sprayer hose','replacement nozzle');
    if(/(milwaukee|dewalt|makita|power tool|drill|grinder|impact)/.test(all)) add((ctx.vendor+' battery').trim(),(ctx.vendor+' charger').trim(),'tool battery','tool charger');
    if(/(jacket|coat|parka|waterproof)/.test(all)) add((ctx.vendor+' overtrousers').trim(),'waterproof trousers','work gloves');
    if(/(trouser|pants|bib|brace)/.test(all)) add('work socks','farm belt','work gloves');
    if(/(glove|gloves)/.test(all)) add('hand cleaner','work socks');
    if(/(mastitis|udder)/.test(all)) add('mastitis test kit','teat wipes','udder gloves');
    if(/(calf|youngstock)/.test(all) && q.length===0) add('calf teat','electrolytes','strong iodine');
    if(!/\bsocks?\b/.test(title)) add(title.replace(/\b\d+(?:\.\d+)?\s*(?:ml|l|kg|g|mm|cm|m)?\b/ig,' ').replace(/\s+/g,' ').trim()+' accessory');
    return q.filter(Boolean).slice(0,6);
  }
  function imageFrom(value){
    if(!value) return '';
    if(typeof value==='string') return value;
    if(typeof value==='object'){
      if(typeof value.url==='string') return value.url;
      if(typeof value.src==='string') return value.src;
      if(value.preview_image) return imageFrom(value.preview_image);
    }
    return '';
  }
  function imageUrl(p){
    var img=imageFrom(p._cfs_image)||imageFrom(p.image)||imageFrom(p.featured_image)||imageFrom(p.featured_media);
    if(!img && p.images && p.images.length) img=imageFrom(p.images[0]);
    if(!img && p.variants && p.variants.length) img=imageFrom(p.variants[0].featured_image);
    return img;
  }
  async function hydrateImages(root,products){
    var base=(root.dataset.root||'/'); if(!base.endsWith('/')) base+='/';
    await Promise.all(products.slice(0,3).map(async function(p){
      if(imageUrl(p)) return;
      var path=String(p.url||'');
      if(!path && p.handle) path='products/'+p.handle;
      if(!path) return;
      path=path.replace(/^https?:\/\/[^/]+\//,'/').replace(/\?.*$/,'').replace(/\.js$/,'');
      if(path.charAt(0)==='/') path=path.slice(1);
      try{
        var r=await fetch(base+path+'.js',{headers:{'Accept':'application/json'}});
        if(!r.ok) return;
        var data=await r.json();
        p._cfs_image=imageFrom(data.featured_image)||(data.images&&data.images.length?imageFrom(data.images[0]):'');
        if(data.variants&&data.variants.length){p.variants=data.variants;p._cfs_variant_price_mode='minor';}
        if(typeof data.available!=='undefined')p.available=data.available;
      }catch(e){}
    }));
    return products;
  }
  async function predictive(root,q){
    var base=(root.dataset.root||'/'); if(!base.endsWith('/')) base+='/';
    var url=base+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    var r=await fetch(url,{headers:{'Accept':'application/json'}}); if(!r.ok) throw new Error('search');
    var data=await r.json(); return ((((data||{}).resources||{}).results||{}).products||[]).map(function(p){p._cfs_price_mode='major';p._cfs_variant_price_mode='major';return p;});
  }
  async function recommendations(root,intent){
    var base=(root.dataset.root||'/'); if(!base.endsWith('/')) base+='/';
    var id=encodeURIComponent(root.dataset.productId||''); if(!id) return [];
    var r=await fetch(base+'recommendations/products.json?product_id='+id+'&limit=10&intent='+encodeURIComponent(intent),{headers:{'Accept':'application/json'}});
    if(!r.ok) return [];
    var data=await r.json(); return (data.products||[]).map(function(p){p._cfs_price_mode='minor';p._cfs_variant_price_mode='minor';return p;});
  }
  function variantMoney(p,v){
    var mode=p._cfs_variant_price_mode||p._cfs_price_mode||'minor';
    return mode==='minor'?formatMinor(v.price):formatMajor(v.price);
  }
  function render(root,products,label){
    if(!products.length) return false;
    var list=root.querySelector('[data-cfs-inline-fbt-list]'); if(!list) return false;
    if(list.children.length) {root.hidden=false; return true;}
    list.innerHTML=products.slice(0,3).map(function(p,idx){
      var img=imageUrl(p);
      var tags=(p.tags||[]).map(function(t){return String(t).toLowerCase();});
      var rx=tags.indexOf('lm')>=0;
      var variants=(p.variants||[]).filter(function(v){return v && v.id && v.available!==false;});
      var base=(root.dataset.root||'/'); if(!base.endsWith('/')) base+='/';
      var action='';
      if(!rx && p.available!==false && variants.length){
        if(variants.length===1){
          action='<form class="cfs-fbt-form" method="post" action="'+esc(base+'cart/add')+'"><input type="hidden" name="id" value="'+esc(variants[0].id)+'"><input type="hidden" name="quantity" value="1"><button type="submit">Add</button></form>';
        }else{
          var opts=variants.map(function(v){return '<option value="'+esc(v.id)+'" data-price="'+esc(variantMoney(p,v))+'">'+esc(v.title)+(v.price!=null?' — '+esc(variantMoney(p,v)):'')+'</option>';}).join('');
          action='<form class="cfs-fbt-form cfs-fbt-form--variants" method="post" action="'+esc(base+'cart/add')+'"><label class="cfs-fbt-variant-label" for="CfsAutoFbt'+idx+'">Choose option</label><select class="cfs-fbt-variant-select" id="CfsAutoFbt'+idx+'" name="id" data-cfs-fbt-variant-select>'+opts+'</select><input type="hidden" name="quantity" value="1"><button type="submit">Add</button></form>';
        }
      }else{
        action='<a href="'+esc(p.url)+'">View</a>';
      }
      var price=p._cfs_price_mode==='minor'?formatMinor(p.price):formatMajor(p.price);
      var media=img?'<img src="'+esc(img)+'" alt="'+esc(p.title)+'" loading="lazy">':'<span class="cfs-inline-fbt-noimage">+</span>';
      return '<article class="cfs-inline-fbt-item">'+
        '<a class="cfs-inline-fbt-image" href="'+esc(p.url)+'">'+media+'</a>'+ 
        '<div class="cfs-inline-fbt-copy">'+(label?'<em class="cfs-fbt-match-badge">'+esc(label)+'</em>':'')+(p.vendor?'<span>'+esc(p.vendor)+'</span>':'')+'<a href="'+esc(p.url)+'"><strong>'+esc(p.title)+'</strong></a><b data-cfs-fbt-price>'+price+'</b></div>'+ 
        '<div class="cfs-inline-fbt-action">'+action+'</div></article>';
    }).join('');
    list.querySelectorAll('[data-cfs-fbt-variant-select]').forEach(function(sel){
      sel.addEventListener('change',function(){
        var item=sel.closest('.cfs-inline-fbt-item');
        var price=item&&item.querySelector('[data-cfs-fbt-price]');
        var opt=sel.options[sel.selectedIndex];
        if(price&&opt&&opt.dataset.price)price.textContent=opt.dataset.price;
      });
      sel.dispatchEvent(new Event('change'));
    });
    root.hidden=false; return true;
  }
  async function show(root,products,label){
    if(!products.length) return false;
    await hydrateImages(root,products);
    return render(root,products,label);
  }
  async function init(root){
    if(!root || root.dataset.autoDone==='1') return; root.dataset.autoDone='1';
    var list=root.querySelector('[data-cfs-inline-fbt-list]');
    if(list && list.children.length){root.hidden=false;return;}
    var currentId=String(root.dataset.productId||''), ctx=context(root);
    try{
      var comp=(await recommendations(root,'complementary')).filter(function(p){return String(p.id)!==currentId && p.available;});
      if(await show(root,comp,'Matched add-on')) return;
    }catch(e){}
    var map=new Map(), queries=smartQueries(ctx);
    for(var qi=0;qi<queries.length;qi++){
      try{(await predictive(root,queries[qi])).forEach(function(p){if(String(p.id)!==currentId&&!map.has(String(p.id)))map.set(String(p.id),p);});}catch(e){}
      if(map.size>=14) break;
    }
    var ranked=[].slice.call(map.values()).map(function(p){return {p:p,s:score(p,ctx)};}).filter(function(x){return x.s>=8;}).sort(function(a,b){return b.s-a.s;}).map(function(x){return x.p;});
    if(await show(root,ranked,'Smart match')) return;
    try{
      var rel=(await recommendations(root,'related')).filter(function(p){
        if(String(p.id)===currentId || !p.available) return false;
        return score(p,ctx)>=12;
      }).sort(function(a,b){return score(b,ctx)-score(a,ctx);});
      await show(root,rel,'Suggested extra');
    }catch(e){}
  }
  function boot(){document.querySelectorAll('[data-cfs-inline-fbt]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

/* V84: remove orphan/legacy product accordions and force closed accordions to collapse. */
(function(){
  function cleanProductAccordions(){
    var info=document.querySelector('.cfs-product-info'); if(!info) return;
    info.querySelectorAll('details').forEach(function(d){
      var summary=d.querySelector(':scope > summary');
      var text=summary?String(summary.textContent||'').trim().toLowerCase():'';
      var ours=d.classList.contains('cfs-product-support-accordion')||d.classList.contains('cfs-product-full-details')||d.classList.contains('cfs-product-reviews');
      if(!ours && text==='details') d.remove();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',cleanProductAccordions);else cleanProductAccordions();
  document.addEventListener('shopify:section:load',cleanProductAccordions);
})();

/* V81: reviews stay collapsed until requested; rating link opens them */
(function(){
  function wireReviews(){
    var reviews=document.getElementById('looxReviews');
    if(!reviews || reviews.tagName.toLowerCase()!=='details') return;
    document.querySelectorAll('a[href="#looxReviews"]').forEach(function(link){
      if(link.dataset.cfsReviewWired==='1') return;
      link.dataset.cfsReviewWired='1';
      link.addEventListener('click',function(){reviews.open=true;});
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',wireReviews); else wireReviews();
  document.addEventListener('shopify:section:load',wireReviews);
})();







/* V89: clean reviews accordion without rewriting the outer summary. */
(function(){
  function prepareReviews(){
    var outer=document.getElementById('looxReviews');
    if(!outer) return;
    function flattenInner(){
      outer.querySelectorAll('details').forEach(function(d){
        if(d===outer) return;
        d.open=true;
        d.classList.add('cfs-loox-inner-details');
      });
    }
    if(!outer.dataset.cfsV89Wired){
      outer.dataset.cfsV89Wired='1';
      outer.addEventListener('toggle',function(){
        if(outer.open){ flattenInner(); setTimeout(flattenInner,250); setTimeout(flattenInner,900); }
      });
      new MutationObserver(function(){ if(outer.open) flattenInner(); }).observe(outer,{childList:true,subtree:true});
    }
    if(outer.open) flattenInner();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',prepareReviews);else prepareReviews();
  document.addEventListener('shopify:section:load',prepareReviews);
})();


/* V90: keep product information/reviews clean and remove duplicate app "Details" rows. */
(function(){
  function cleanLegacyDetails(){
    var root=document.querySelector('.cfs-product-main'); if(!root) return;
    var reviews=root.querySelector('.cfs-product-reviews');
    root.querySelectorAll('details').forEach(function(d){
      if(d.classList.contains('cfs-product-support-accordion')||d.classList.contains('cfs-product-full-details')||d.classList.contains('cfs-product-reviews')) return;
      var sum=d.querySelector(':scope > summary');
      var txt=sum?String(sum.textContent||'').trim().toLowerCase():'';
      if(txt==='details'){
        if(reviews&&reviews.contains(d)){
          d.open=true; d.classList.add('cfs-loox-inner-details');
        }else{
          d.hidden=true; d.setAttribute('aria-hidden','true');
        }
      }
    });
  }
  function boot(){cleanLegacyDetails();setTimeout(cleanLegacyDetails,300);setTimeout(cleanLegacyDetails,1200);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  var target=document.querySelector('.cfs-product-main');
  if(target)new MutationObserver(cleanLegacyDetails).observe(target,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',boot);
})();


/* V90: update add-on price when a customer chooses an add-on variant. */
(function(){
  function wire(root){
    (root||document).querySelectorAll('[data-cfs-fbt-variant-select]').forEach(function(sel){
      if(sel.dataset.cfsVariantPriceWired==='1')return;
      sel.dataset.cfsVariantPriceWired='1';
      function update(){
        var item=sel.closest('.cfs-inline-fbt-item');var price=item&&item.querySelector('[data-cfs-fbt-price]');var opt=sel.options[sel.selectedIndex];
        if(price&&opt&&opt.dataset.price)price.textContent=opt.dataset.price;
      }
      sel.addEventListener('change',update);update();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){wire(document);});else wire(document);
  new MutationObserver(function(m){m.forEach(function(x){x.addedNodes.forEach(function(n){if(n.nodeType===1)wire(n);});});}).observe(document.documentElement,{childList:true,subtree:true});
})();


/* V91: permanently flatten/remove Loox's generic "Details" row without touching CFS accordions. */
(function(){
  function textOf(el){return String((el&&el.textContent)||'').replace(/\s+/g,' ').trim().toLowerCase();}
  function clean(){
    var main=document.querySelector('.cfs-product-main');
    if(!main)return;
    var reviews=main.querySelector('.cfs-product-reviews');

    main.querySelectorAll('details').forEach(function(d){
      if(d.classList.contains('cfs-product-support-accordion')||d.classList.contains('cfs-product-full-details')||d.classList.contains('cfs-product-reviews'))return;
      var s=d.querySelector(':scope > summary');
      if(textOf(s)==='details'){
        if(reviews && reviews.contains(d)){
          d.open=true;
          d.classList.add('cfs-loox-inner-details');
          if(s)s.setAttribute('data-cfs-hide-loox-details','1');
        }else{
          d.hidden=true;
          d.setAttribute('aria-hidden','true');
        }
      }
    });

    if(reviews){
      reviews.querySelectorAll('summary,button,[role="button"]').forEach(function(el){
        if(textOf(el)!=='details')return;
        var d=el.closest('details');
        if(d && d!==reviews){
          d.open=true;
          d.classList.add('cfs-loox-inner-details');
          el.setAttribute('data-cfs-hide-loox-details','1');
        }else{
          el.setAttribute('data-cfs-hide-loox-details','1');
        }
      });
    }
  }
  function boot(){clean();setTimeout(clean,150);setTimeout(clean,600);setTimeout(clean,1800);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
  var root=document.querySelector('.cfs-product-main');
  if(root)new MutationObserver(clean).observe(root,{childList:true,subtree:true});
})();

/* V92: product disclosure controls use buttons instead of native <details>. */
(function(){
  function setState(btn, open){
    var id=btn.getAttribute('aria-controls');
    var panel=id?document.getElementById(id):null;
    btn.setAttribute('aria-expanded', open?'true':'false');
    var icon=btn.querySelector('.cfs-disclosure-icon');
    if(icon && !open) icon.textContent='+';
    if(icon && open) icon.textContent='';
    if(panel) panel.hidden=!open;
    if(open && panel && panel.classList.contains('cfs-product-review-panel')) cleanLoox(panel);
  }
  function cleanLoox(scope){
    var widget=(scope||document).querySelector('#looxReviews');
    if(!widget)return;
    widget.querySelectorAll('summary,button,[role="button"]').forEach(function(el){
      var text=String(el.textContent||'').replace(/\s+/g,' ').trim().toLowerCase();
      if(text!=='details')return;
      var details=el.closest('details');
      if(details && widget.contains(details)){
        details.open=true;
        details.setAttribute('data-cfs-loox-wrapper','1');
      }
      el.setAttribute('data-cfs-loox-details-label','1');
    });
  }
  function wire(root){
    (root||document).querySelectorAll('[data-cfs-disclosure-toggle]').forEach(function(btn){
      if(btn.dataset.cfsDisclosureWired==='1')return;
      btn.dataset.cfsDisclosureWired='1';
      setState(btn,false);
      btn.addEventListener('click',function(){setState(btn,btn.getAttribute('aria-expanded')!=='true');});
    });
    (root||document).querySelectorAll('a[href="#cfsReviews"]').forEach(function(link){
      if(link.dataset.cfsReviewLinkWired==='1')return;
      link.dataset.cfsReviewLinkWired='1';
      link.addEventListener('click',function(e){
        e.preventDefault();
        var wrap=document.getElementById('cfsReviews');
        var btn=wrap&&wrap.querySelector('[data-cfs-disclosure-toggle]');
        if(btn)setState(btn,true);
        if(wrap)wrap.scrollIntoView({behavior:'smooth',block:'start'});
      });
    });
    cleanLoox(root||document);
  }
  function boot(){wire(document);setTimeout(function(){wire(document);},350);setTimeout(function(){wire(document);},1200);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
  new MutationObserver(function(muts){
    muts.forEach(function(m){m.addedNodes.forEach(function(n){if(n.nodeType===1)wire(n);});});
  }).observe(document.documentElement,{childList:true,subtree:true});
})();

/* V102: automatically move the mobile brand row while preserving manual swipe. */
(function(){
  function initBrandCarousel(root){
    (root||document).querySelectorAll('[data-cfs-brand-carousel]').forEach(function(track){
      if(track.dataset.cfsAutoBrandWired==='1') return;
      track.dataset.cfsAutoBrandWired='1';
      var mq=window.matchMedia('(max-width: 760px)');
      var reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
      var paused=false, timer=null, resumeTimer=null;
      function step(){
        if(!mq.matches || reduce.matches || paused) return;
        var first=track.querySelector('.cfs-brand-tile');
        if(!first) return;
        var gap=parseFloat(getComputedStyle(track).gap)||10;
        var amount=first.getBoundingClientRect().width+gap;
        var nearEnd=track.scrollLeft+track.clientWidth>=track.scrollWidth-amount*.7;
        if(nearEnd){
          track.scrollTo({left:0,behavior:'smooth'});
        }else{
          track.scrollBy({left:amount,behavior:'smooth'});
        }
      }
      function start(){
        stop();
        if(mq.matches && !reduce.matches) timer=setInterval(step,2800);
      }
      function stop(){if(timer){clearInterval(timer);timer=null;}}
      function userPause(){
        paused=true; stop();
        if(resumeTimer)clearTimeout(resumeTimer);
        resumeTimer=setTimeout(function(){paused=false;start();},5000);
      }
      ['touchstart','pointerdown','wheel'].forEach(function(ev){track.addEventListener(ev,userPause,{passive:true});});
      track.addEventListener('mouseenter',function(){paused=true;stop();});
      track.addEventListener('mouseleave',function(){paused=false;start();});
      if(mq.addEventListener)mq.addEventListener('change',start);
      start();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initBrandCarousel(document);});else initBrandCarousel(document);
  document.addEventListener('shopify:section:load',function(e){initBrandCarousel(e.target);});
})();
